/*jshint esversion: 6 */
import store from '@/store/index';
import UltraRoute from '@/router/components/UltraRoute.js';
import WorkPackageImageZoom from '@/router/modules/WorkPackageImageZoom.module.js';
import WorkPackageEditorModule from '@/router/modules/WorkPackageEditor.module.js';

function infoBoxRouting(to, from, next, step_type, location, down, up) {
  let prefix = '';
  switch (to.params.info_box_template_type) {
    case 'company':
      prefix = 'b';
      break;
    case 'community':
      prefix = 'c';
      break;
  }
  let sub_prefix = to.params.info_box_template_type === 'recommendation'?
    's':'w';
  let work_package =
    to.params.info_box_template_type === 'recommendation'?
    store.getters['WorkBench/getWBObject']({
      type: 'wagworkpackagerecommendations',
      id: to.params.waggon_id
    }).workpackages[to.params.workpackage_id]
    :
    store.getters['WorkBench/getWBObject']({
      type: `${prefix}workpackages`,
      id: to.params.workpackage_id,
    });
  if (work_package[`${prefix}${sub_prefix}${step_type}`] && work_package[`${prefix}${sub_prefix}${step_type}`].length === 0) {
    if (to.params.direction === 'down') {
      return {
        name: `${location}WorkPackageInfoBox${down}`,
        params: {direction: 'down'}
      };
    } else {
      return {
        name: `${location}WorkPackageInfoBox${up}`,
        params: {direction: 'up'}
      };
    }
  } else {
    next();
  }
}


function Template(payload) {
  let route = UltraRoute({
    name: `${payload.location}WorkPackageInfoBox`,
    path: ':info_box_template_type/:workpackage_id',
    folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
    file: 'WorkBenchWorkPackageInfoBox',
    auth:true,
    redirect: `${payload.location}WorkPackageInfoBoxInfo`,
    props: (route) => {
      return {
        workpackage_id: parseInt(route.params.workpackage_id),
        template_type: route.params.info_box_template_type,
        waggon_id: parseInt(route.params.waggon_id),
        create: route.params.waggon_id === 'create'?true:false,
        location: payload.location
      };
    },
    children: [
      UltraRoute({
        path: 'info',
        name: `${payload.location}WorkPackageInfoBoxInfo`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxInfo',
        auth:true
      }),
      UltraRoute({
        path: 'worksteps',
        name: `${payload.location}WorkPackageInfoBoxWorkSteps`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxSteps',
        auth:true,
        props: () => {
          return {
            step_type: 'worksteps'
          };
        },
        before_enter: (to, from, next) => {
          infoBoxRouting(to, from, next, 'worksteps', payload.location, 'QualitySteps', 'Info')
        },
      }),
      UltraRoute({
        path: 'qualitysteps',
        name: `${payload.location}WorkPackageInfoBoxQualitySteps`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxSteps',
        auth:true,
        props: () => {
          return {
            step_type: 'qualitysteps'
          };
        },
        before_enter: (to, from, next) => {
          infoBoxRouting(to, from, next, 'qualitysteps', payload.location, 'WorkSteps', 'DefectSteps')
        },
      }),
      UltraRoute({
        path: 'defectsteps',
        name: `${payload.location}WorkPackageInfoBoxDefectSteps`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxSteps',
        auth:true,
        props: () => {
          return {
            step_type: 'defectsteps'
          };
        },
        before_enter: (to, from, next) => {
          infoBoxRouting(to, from, next, 'defectsteps', payload.location, 'QualitySteps', 'HandoverSteps')
        },
      }),
      UltraRoute({
        path: 'handoversteps',
        name: `${payload.location}WorkPackageInfoBoxHandoverSteps`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxSteps',
        auth:true,
        props: () => {
          return {
            step_type: 'handoversteps'
          };
        },
        before_enter: (to, from, next) => {
          infoBoxRouting(to, from, next, 'handoversteps', payload.location, 'DefectSteps', 'DesignSteps')
        },
      }),
      UltraRoute({
        path: 'designsteps',
        name: `${payload.location}WorkPackageInfoBoxDesignSteps`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxSteps',
        auth:true,
        props: () => {
          return {
            step_type: 'designsteps'
          };
        },
        before_enter: (to, from, next) => {
          infoBoxRouting(to, from, next, 'designsteps', payload.location, 'HandoverSteps', 'LogisticSteps')
        },
      }),
      UltraRoute({
        path: 'logisticsteps',
        name: `${payload.location}WorkPackageInfoBoxLogisticSteps`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxSteps',
        auth:true,
        props: () => {
          return {
            step_type: 'logisticsteps'
          };
        },
        before_enter: (to, from, next) => {
          infoBoxRouting(to, from, next, 'logisticsteps', payload.location, 'DesignSteps', 'MaterialSteps')
        },
      }),
      UltraRoute({
        path: 'materialsteps',
        name: `${payload.location}WorkPackageInfoBoxMaterialSteps`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxSteps',
        auth:true,
        props: () => {
          return {
            step_type: 'materialsteps'
          };
        },
        before_enter: (to, from, next) => {
          infoBoxRouting(to, from, next, 'materialsteps', payload.location, 'LogisticSteps', 'NoSteps')
        },
      }),
      UltraRoute({
        path: 'nosteps',
        name: `${payload.location}WorkPackageInfoBoxNoSteps`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxNoSteps',
        auth:true,
        props: () => {
          return {
            step_type: 'nosteps'
          };
        },
        before_enter: (to, from, next) => {
          let prefix = '';
          switch (to.params.info_box_template_type) {
            case 'company':
              prefix = 'b';
              break;
            case 'community':
              prefix = 'c';
              break;
          }
          let sub_prefix = to.params.info_box_template_type === 'recommendation'?
            's':'w';
          let work_package =
            to.params.info_box_template_type === 'recommendation'?
            store.getters['WorkBench/getWBObject']({
              type: 'wagworkpackagerecommendations',
              id: to.params.waggon_id
            }).workpackages[to.params.workpackage_id]
            :
            store.getters['WorkBench/getWBObject']({
              type: `${prefix}workpackages`,
              id: to.params.workpackage_id,
            });
          if (work_package[`${prefix}${sub_prefix}worksteps`] && work_package[`${prefix}${sub_prefix}worksteps`].length === 0) {
            if (to.params.direction === 'down') {
              return {
                name: 'WorkBenchWaggonWorkPackageInfoBoxQualitySteps',
                params: {direction: 'down'}
              };
            } else {
              return {
                name: 'WorkBenchWaggonWorkPackageInfoBoxInfo',
                params: {direction: 'up'}
              };
            }
          } else {
            next();
          }
        },
      }),
      WorkPackageImageZoom(Object.assign(JSON.parse(JSON.stringify(payload)), {
        location: `${payload.location}WorkPackageInfoBox`,
        close: `${payload.location}WorkPackageInfoBox`
      })),
      UltraRoute({
        path: 'costs',
        name: `${payload.location}WorkPackageInfoBoxCosts`,
        folder: 'WorkBenchRework/WorkBenchWorkPackageInfoBox',
        file: 'WorkBenchWorkPackageInfoBoxCosts',
        auth:true
      }),
      WorkPackageEditorModule({
        path: 'edit',
        location: `${payload.location}WorkPackageInfoBox`,
        read_only: false,
        nav_back: `${payload.location}WorkPackageInfoBoxInfo`
      })
    ]
  });
  return route;
}
export default Template;
